<template>
  <div
    class="container-fluid animated fadeIn bg-info "
    style="line-height: 60px;flex: 0 0 auto;">
    <b-container>
      <b-row>
        <b-col cols="2">

          <b-img src="https://open.weixin.qq.com/qr/code?username=ruiyidianzi" alt="公众号" width="120px" height="120px" style="margin-top:20px"/>
        </b-col>
        <b-col >
          <div class="row justify-content-center">
            <!-- <span style="word-break:all;word-break:normal; width:auto; display:block;white-space:pre-wrap;word-wrap : break-word ;overflow: hidden;">Copyright © 2011-2018 www.rayetech.com 烟台市锐易电子技术有限公司
</span> -->
            <span >Copyright © 2011-2020 www.ruiyidianzi.net
            </span>
          </div>
          <div class="row justify-content-center">

            <span >烟台市锐易电子技术有限公司
            </span>
          </div>
          <div class="row justify-content-center">
            <span >
              <!-- <div style="width:300px;margin:0 auto; padding:20px 0;"> -->
              <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37060202000762" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#fff;"><img :src="`${baseUrl}img/ghs.png`" style="float:left;"> 鲁公网安备 37060202000762号</a>
              &nbsp;&nbsp;<a href="http://www.miibeian.gov.cn" rel="nofollow" target="_blank" style="color:#fff;">鲁ICP备18049864号</a>
            <!-- </div> -->
            </span>
          </div>
        </b-col>
        <b-col cols="2"/>
        <slot/>
      </b-row>
    </b-container>
  </div>

</template>
<style scoped>

/* .footer {
  position: relative;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #343a40;
  word-break: break-all;
  word-wrap: break-word;
}*/
</style>
<!-- {{baseUrl}},{{baseApiUrl}},{{tilte}},{{mytilte}} -->
<script>
import store from '@/store'

export default {
  name: 'MyFooter',
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      // 使用环境变量中的全局变量
      baseApiUrl: process.env.VUE_APP_API_URL,
      // 使用注册组件的环境变量，利用prototype
      tilte: this.CompanyName.tilte,
      // 使用vuex 中的store 存储全局变量
      mytilte: this.$store.getters.GlobalVariable.globalCompanyName
    }
  }
}
</script>
